import * as u from './utils';

export default () => {
    const container = document.querySelectorAll('.design-slider');

    if (!container) {
        return;
    }

    for (const el of container) {
        if (el.dataset.json === '' || !u.isJsonString(el.dataset.json)) {
            continue;
        }

        const input = el.querySelector('.design-slider__input input');
        const usersDisplay = el.querySelector('.design-slider__count--users');
        const sizeDisplay = el.querySelector('.design-slider__count--size');
        const imageDisplay = el.querySelector('.design-slider__image');
        const data = JSON.parse(el.dataset.json);

        const handleChange = () => {
            usersDisplay.innerHTML = data[input.value].users;
            sizeDisplay.innerHTML = data[input.value].size;
            imageDisplay.setAttribute('src', data[input.value].image);
        };

        input.addEventListener('input', handleChange);
    }
};
